import {
    displayShortDateOrNA,
    displayPercentOrNA,
    displayFirstUpperCase
} from '../../utils/Format/Format';

import { showExpenseWaiverDisclaimer } from '../../utils/fund-info';

export const getDisclaimerNumFeeExpenses = (iClass, moneyMarket, bond) => {
    if (!iClass && !moneyMarket && !bond) {
        return '3';
    }
    if (iClass && !moneyMarket && !bond) {
        return '4';
    }
    if (!iClass && bond) {
        return '4';
    }
    if (!iClass && moneyMarket) {
        return '5';
    }
    if (iClass && bond && !moneyMarket) {
        return '5';
    }
    if (iClass && moneyMarket && !bond) {
        return '6';
    }
    return '';
};

export const validateWaiverType = (expenseRatioWaiverType) => {
    if (expenseRatioWaiverType === 'NOT_APPLICABLE') {
        return 'N/A';
    }
    if (
        expenseRatioWaiverType === 'CONTRACTUAL' ||
        expenseRatioWaiverType === 'OTHER'
    ) {
        return displayFirstUpperCase(expenseRatioWaiverType);
    }
    return expenseRatioWaiverType;
};

export const disclaimerNumbersFeeExpenses = (...rest) =>
    `${getDisclaimerNumFeeExpenses(...rest)}`;

export const feesExpensesUtil = (iClass, moneyMarket, bond, ticker, etf) => (
    gqlResult
) => {
    if (!gqlResult) return null;
    const {
        grossExpenseRatio,
        netExpenseRatio,
        expenseRatioWaiverType,
        expenseRatioWaiverExpirationDate,
        transactionFee
    } =
        gqlResult.exchangeTradedFund || gqlResult.mutualFund;
    const title = etf ? 'Expenses' : 'Fees & Expenses';

    const returnData = [
        {
            label: `Gross Expense Ratio`,
            labelSup: `${disclaimerNumbersFeeExpenses(
                iClass,
                moneyMarket,
                bond
            )}${showExpenseWaiverDisclaimer(ticker) ? ' *' : ''}`,
            values: [{ val1: displayPercentOrNA(grossExpenseRatio) }],
            showDefinition: false,
            definition: `The gross expense ratio reflects the fund expenses as stated in the fee table of the fund's prospectus prior to the deduction of any waiver or reimbursement. Expense ratios are as of the most recent prospectus.`
        },
        {
            label: `Net Expense Ratio`,
            labelSup: `${disclaimerNumbersFeeExpenses(
                iClass,
                moneyMarket,
                bond
            )}${showExpenseWaiverDisclaimer(ticker) ? ' *' : ''}`,
            values: [{ val1: displayPercentOrNA(netExpenseRatio) }],
            showDefinition: false,
            definition: `The net expense ratio reflects fund expenses after the deduction of any waiver or reimbursement. Expense ratios are as of the most recent prospectus.`
        }
    ];

    return {
        data: gqlResult.exchangeTradedFund
            ? returnData
            : [
                  ...returnData,
                  {
                      label: 'Expense Waiver Type',
                      values: [
                          {
                              val1: validateWaiverType(expenseRatioWaiverType)
                          }
                      ]
                  },
                  {
                      label: 'Expense Limitation Expires',
                      values: [
                          {
                              val1: displayShortDateOrNA(
                                  expenseRatioWaiverExpirationDate
                              )
                          }
                      ]
                  },
                  {
                      label: 'Transaction Fee',
                      values: [
                          { val1: !transactionFee ? 'None' : transactionFee }
                      ],
                      showDefinition: false,
                      definition: `A fund with a fee for buying or selling shares, similar to a brokerage fee or commission paid when a stock is bought or sold. Many funds in the Mutual Fund Gateway are available without remaining funds. Please note that T. Rowe Price Investment Services, Inc. may receive administrative fees of up to 40 basis points from funds that do not charge a transaction fee for providing record keeping and shareholder services.`
                  }
              ],

        title
    };
};
